// extracted by mini-css-extract-plugin
export default {"container":"User_container__Wcy0R","formContainer":"User_formContainer__I18oN","deleteUser":"User_deleteUser__azefV","title":"User_title__qJpPg"};